import { InfoBar } from '@2n/design-system';
import * as React from 'react';

export interface IWarningBarData {
  title?: string;
  children: React.ReactNode;
}

export function FilledWarningBar(data: IWarningBarData) {
  return (
    <InfoBar
      variant="standard"
      type="warning"
      title={data.title || undefined}
      sx={{
        backgroundColor: 'warning.alert.background',
        color: 'warning.text',
      }}
    >
      {data.children}
    </InfoBar>
  );
}
